import { DragOverlay, useDndContext } from '@dnd-kit/core'
import { GripVertical } from 'lucide-react'
import { useMemo, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * What is in the air while a row is dragged — what
 * `SortableConfig.dragPreview` names.
 *
 * Portalled to the body, because the table scrolls and clips.
 *
 * `useDndContext` re-renders this on every pointer move of a drag, so the
 * label is asked for once per gesture and not once per pixel.
 *
 * @single-use the drag marker of `DataTable`
 */
export function DataTableDragPreview({
  render,
}: {
  render: (activeKey: string) => ReactNode
}) {
  const { active } = useDndContext()
  const label = useMemo(
    () => (active ? render(String(active.id)) : null),
    [active, render],
  )

  return createPortal(
    <DragOverlay dropAnimation={null}>
      {label ? (
        <span className="pointer-events-none inline-flex w-max cursor-grabbing items-center gap-2 whitespace-nowrap rounded-md border border-border bg-card px-2.5 py-1.5 text-[13px] text-foreground shadow-md">
          <GripVertical size={14} className="text-faint" />
          {label}
        </span>
      ) : null}
    </DragOverlay>,
    document.body,
  )
}
